import React, { useEffect, useState } from 'react'
import './EasySteps.css';
import EasyStepCard from './Component/EasyStepCard';
import DematEasySteps from '../../Data/DematEasySteps';
import Button from '../../Components/Button/Button';
import SectionIds from '../../Helper/SectionId';
import { useRef } from 'react';
import goToLink from '../../Helper/GoToLink';
import GoToLinks from '../../Data/GoToLinks';
import { useInView } from 'framer-motion';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics';
export default function EasySteps() {
  const [activeCardIndex, setActiveCardIndex] = useState(0);
  const [pauseTimer, setPauseTimer] = useState(false);
  const sectionRef = useRef(null);
  const inView = useInView(sectionRef);
  const onClickButtonHandle = () => goToLink(GoToLinks.accountOpening);

  useEffect(() => {

    if (inView) {
      setActiveCardIndex(0);
      setPauseTimer(false);
    }
    else
      setPauseTimer(true)


  }, [inView])


  useEffect(() => {

    const timer = setInterval(
      () => {

        if (!pauseTimer) {

          setActiveCardIndex(prevIndex => {

            if (prevIndex === DematEasySteps.length - 1) {
              return 0;
            }
            else {
              return prevIndex + 1;
            }
          })
        }
      }, 2000
    );
    return () => clearInterval(timer)

  }, [pauseTimer])

  return (
    <SectionWithAnalytics className='section section-easy-steps gap-700 container-vertical' id={SectionIds.section3EasySteps} ref={sectionRef}>

      <div className='container-vertical res-gap-24'>
        <h4 className='text-align-center'>How to open <mark>Demat Account</mark> with us</h4>
        <div className='text-align-center fs-medium clr-grey-600 fw-regular'>3-Easy Steps. Get Started Now</div>
      </div>

      <main className='content-wrapper container-vertical gap-700'>
        <div className='content'>
          {DematEasySteps.map((element, index) => {
            return <EasyStepCard
              key={index}
              step={element.step}
              heading={element.heading}
              content={element.content}
              active={index === activeCardIndex}
              onMouseOver={() => {
                setActiveCardIndex(index);
                setPauseTimer(true);
              }}
              onMouseLeave={() => {
                setPauseTimer(false)
              }} />
          })}

        </div>
        <Button className='navbar-cta' name="Get Started" onClick={onClickButtonHandle} />
      </main>
    </SectionWithAnalytics>
  )
}
